import { FormFeedBack, ModalBase, Select } from '@repo/ui';
import { ListCourseResponse } from 'domain/models/responses';
import { GetAllEntitiesResponse } from 'domain/models/responses';
import { FormikValues } from 'formik';
import { Col, Form, Input, Label, Row } from 'reactstrap';

interface IProps {
  isOpen: boolean;
  loading: boolean;
  formik: FormikValues;
  entitiesList: GetAllEntitiesResponse[];
  coursesList: ListCourseResponse[];
  toggleModal: () => void;
  resetForm: () => void;
}

export const ModalEditPartner = ({
  isOpen,
  loading,
  formik,
  entitiesList,
  coursesList,
  toggleModal,
  resetForm,
}: IProps) => {
  const entitiesOptions = entitiesList.map((e) => ({ label: e.name, value: e.id }));
  const coursesOptions = coursesList.map((c) => ({ label: c.nome, value: c.id }));

  return (
    <ModalBase.Wrapper
      size="lg"
      isOpen={isOpen}
      loading={loading}
      toggle={toggleModal}
      onClosed={resetForm}
    >
      <ModalBase.Header toggle={toggleModal} withBorderBottom>
        Editar Parceiro
      </ModalBase.Header>

      <Form autoComplete="off" onSubmit={formik.handleSubmit}>
        <ModalBase.Body>
          <Row>
            <Col md={6} className="mb-3">
              <Label className="form-label">Nome do parceiro</Label>
              <Input
                type="text"
                name="partnerName"
                className="form-control"
                value={formik.values.partnerName}
                disabled
              />
            </Col>

            <Col md={6} className="mb-3">
              <Label className="form-label">Chave</Label>
              <Input
                type="text"
                name="key"
                className="form-control"
                value={formik.values.key}
                disabled
              />
            </Col>

            <Col md={12} className="mb-3">
              <Label htmlFor="description" className="form-label">
                Descrição
              </Label>
              <Input
                id="description"
                type="textarea"
                name="description"
                rows={3}
                className="form-control"
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={
                  formik.touched.description && !!formik.errors.description
                }
              />
              <FormFeedBack
                error={formik.errors.description}
                isInvalid={
                  formik.touched.description && !!formik.errors.description
                }
              />
            </Col>

            <Col md={12} className="mb-3">
              <Label htmlFor="redirectUrl" className="form-label">
                URL de redirecionamento
              </Label>
              <Input
                id="redirectUrl"
                type="url"
                name="redirectUrl"
                className="form-control"
                placeholder="https://..."
                value={formik.values.redirectUrl}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={
                  formik.touched.redirectUrl && !!formik.errors.redirectUrl
                }
              />
              <FormFeedBack
                error={formik.errors.redirectUrl}
                isInvalid={
                  formik.touched.redirectUrl && !!formik.errors.redirectUrl
                }
              />
            </Col>

            <Col md={12}>
              <div className="form-check form-switch">
                <Input
                  id="active"
                  type="checkbox"
                  name="active"
                  role="switch"
                  className="form-check-input"
                  checked={formik.values.active}
                  onChange={formik.handleChange}
                />
                <Label className="form-check-label" htmlFor="active">
                  {formik.values.active ? 'Ativo' : 'Inativo'}
                </Label>
              </div>
            </Col>

            <Col md={12} className="mb-1 mt-3">
              <p className="fw-semibold text-muted mb-2" style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Escopo
              </p>
              <small className="text-muted d-block mb-3">
                Deixe em branco para aplicar a todas as organizações/cursos.
              </small>
            </Col>

            <Col md={6} className="mb-3">
              <Label className="form-label">Organizações</Label>
              <Select
                isMulti
                isClearable
                placeholder="Todas as organizações"
                options={entitiesOptions}
                value={formik.values.organizations}
                onChange={(opts: any) => formik.setFieldValue('organizations', opts ?? [])}
              />
            </Col>

            <Col md={6} className="mb-3">
              <Label className="form-label">Cursos</Label>
              <Select
                isMulti
                isClearable
                placeholder="Todos os cursos"
                options={coursesOptions}
                value={formik.values.courses}
                onChange={(opts: any) => formik.setFieldValue('courses', opts ?? [])}
              />
            </Col>
          </Row>
        </ModalBase.Body>

        <ModalBase.Footer>
          <ModalBase.Actions
            loading={loading}
            goBack={toggleModal}
            actionBtnType="submit"
          />
        </ModalBase.Footer>
      </Form>
    </ModalBase.Wrapper>
  );
};
